import React from 'react'
import { ComposableMap, Geographies, Geography } from 'react-simple-maps'
import { useContainerWidth, Separator, colors, H3, Subheading } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { arrayOf, number, shape, string } from 'prop-types'
import worldGeo from './data/worldGeo.json'
import countryDetails from '../../../../../shared/data/countryDetails.json'
import CountryPercentage from './CountryPercentage'

export default function GlobalNameCounts({ tileData }) {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()
  const totalCount = tileData?.totalCount ? tileData.totalCount : 0
  const selectedName = tileData?.surname ? tileData.surname : ''

  const countryNameContainerStyle = css`
    width: 100%;
    display: grid;
    grid-template-columns: ${atWidth({ default: '100%', xl: '50% 50%', xxl: '33.3% 33.3% 33.3%' })};
    margin-inline-start: auto;
    margin-inline-end: auto;
  `
  const getColor = (ind) => {
    const c = [
      colors.blue30,
      colors.green30,
      colors.yellow30,
      colors.red60,
      colors.yellow50,
      colors.blue70,
      colors.green50,
      colors.yellow50,
      colors.red80,
    ]
    ind = ind <= c.length - 1 ? ind : 0

    return c[ind]
  }

  return (
    <div
      css={{
        width: '100%',
        minHeight: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <div
        css={{
          maxWidth: '600px',
        }}
      >
        <ComposableMap height={450}>
          <Geographies geography={worldGeo}>
            {({ geographies }) => (
              <>
                {geographies.map((geo) => {
                  if (!tileData) return null
                  const foundInd = tileData?.countries?.findIndex((item) => {
                    return item.code === geo.id
                  })
                  let d = foundInd > -1 ? tileData.countries[foundInd] : null
                  const country = tileData.countries[foundInd]
                  if (country) {
                    const percent = (Number.parseInt(country.count, 10) / totalCount) * 100
                    if (percent <= 0.5) {
                      d = null
                    }
                  }
                  return (
                    <Geography
                      key={geo.rsmKey}
                      stroke="#FFF"
                      geography={geo}
                      fill={d ? getColor(foundInd) : '#F5F4F6'}
                    />
                  )
                })}
              </>
            )}
          </Geographies>
        </ComposableMap>

        {selectedName ? (
          <H3 centered>
            {selectedName}
            <Subheading>{t('aam.tree-surname-count-explanation', { name: selectedName })}</Subheading>
          </H3>
        ) : (
          <H3 centered>
            {t('aam.tree-surname-not-found')}
            <Subheading>{t('aam.tree-surname-not-found-explanation')}</Subheading>
          </H3>
        )}

        <Separator size="sm" />
        <div css={countryNameContainerStyle}>
          {tileData?.countries &&
            tileData.countries.map((country, ind) => {
              const countryDetail = countryDetails.countries.find((item) => {
                return item.alpha3 === country.code
              })
              if (countryDetail?.alpha2) {
                const percent = (Number.parseInt(country.count, 10) / totalCount) * 100
                if (percent <= 0.5) {
                  return null
                }
                return (
                  <CountryPercentage
                    percent={Math.round(percent)}
                    alpha2={countryDetail.alpha2.toUpperCase()}
                    color={getColor(ind)}
                    key={countryDetail.alpha2}
                  />
                )
              }
              return null
            })}
        </div>
        <Separator size="sm" />
      </div>
    </div>
  )
}

GlobalNameCounts.propTypes = {
  tileData: shape({
    res: shape({
      surname: string.isRequired,
      totalCount: number,
      countries: arrayOf(
        shape({
          code: string,
          count: number,
        })
      ),
    }),
  }),
}
